import { useMutation } from '@apollo/client';
import { Col, notification, Row } from 'antd';
import React, { useState } from 'react';
import WithAddableInputFormTemplate from 'routes/Profile/components/ProfileContent/WithAddableInputFormTemplate';
import { INewInitalFieldsProps } from 'routes/Profile/components/ProfileContent/WithAddableInputFormTemplate/types';
import { CREATE_SERVICE_TYPE, UPDATE_SERVICE_TYPE } from 'services/graphql/mutations/services';
import * as Yup from 'yup';

import { IServiceRelatedFormProps } from './types';

const validations = {
  name: Yup.string().required('Required'),
  description: Yup.string().required('Required'),
  // clientRON: Yup.string().required('Required'),
  // clientInPerson: Yup.string().required('Required'),
  // notaryGetRON: Yup.string().required('Required'),
  // notaryGetInPerson: Yup.string().required('Required'),
};

const CreateServiceForm: React.FC<IServiceRelatedFormProps> = ({
  callbackOnCreateSuccess,
  refetch,
  activeService,
  callbackOnEditSuccess,
}) => {
  const [submitLoading, setSubmitLoading] = useState(false);

  const formInputFields: INewInitalFieldsProps[] = [
    {
      inputProps: [
        {
          name: 'name',
          label: 'Service name',
          defaultValue: activeService?.name,
        },
        {
          name: 'description',
          label: 'Description',
          defaultValue: activeService?.description,
        },
      ],
    },
  ];

  const [createService] = useMutation(CREATE_SERVICE_TYPE);
  const [updateService] = useMutation(UPDATE_SERVICE_TYPE);

  const callCreateService = async (v: any) => {
    try {
      if (activeService) {
        await updateService({
          variables: {
            updatedDoc: v,
            filter: {
              id: activeService.id,
            },
          },
        });
        callbackOnEditSuccess?.();
      } else {
        await createService({
          variables: {
            doc: v,
          },
        });
        callbackOnCreateSuccess?.();
      }
      refetch?.();
      notification.success({ message: `${activeService ? 'Update' : 'Create'} service type successfully!` });
    } catch (err) {
      notification.error({ message: `${activeService ? 'Update' : 'Create'} Service type failure! Please try again` });
      console.log('ERROR', err);
    } finally {
      setSubmitLoading(false);
    }
  };

  const onSubmit = (v: any) => {
    setSubmitLoading(true);
    callCreateService(v);
  };

  return (
    <div style={{ maxHeight: 700, overflow: 'auto', padding: '20px' }}>
      <WithAddableInputFormTemplate
        initialFields={formInputFields}
        validation={validations}
        portalButtonClassName='.service-form-submit-button'
        onSubmit={onSubmit}
        submitButtonLabel='Save'
        loading={submitLoading}
      />
      <Row className='gx-mt-3 gx-m-0'>
        <Col span={24}>
          <div className='service-form-submit-button' />
        </Col>
      </Row>
    </div>
  );
};

export default React.memo(CreateServiceForm);
